<div class="element-hover">
  <ng-content></ng-content>
</div>
